import React from 'react';

/**
 * 🔥 ERROR BOUNDARY GLOBAL ULTRA-ROBUSTE
 * Garantit que l'app ne montre JAMAIS un écran noir
 * Même en cas de crash React, on affiche toujours quelque chose
 */
export class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
      errorCount: 0
    };
  }

  static getDerivedStateFromError(error) {
    // Toujours retourner un état pour éviter le crash total
    return {
      hasError: true,
      error: error
    };
  }

  componentDidCatch(error, errorInfo) {
    const errorMessage = String(error?.message || '');
    console.error('🔥 [GlobalErrorBoundary] Erreur capturée:', error, errorInfo);

    // Incrémenter le compteur d'erreurs
    this.setState(prevState => ({
      errorCount: prevState.errorCount + 1,
      errorInfo
    }));

    // Si c'est une erreur DOM, essayer de récupérer
    if (
      /removeChild|NotFoundError|appendChild|DOMException|Failed to execute/i.test(errorMessage)
    ) {
      console.warn('🔥 [GlobalErrorBoundary] Erreur DOM détectée, tentative de récupération...');
      
      // Essayer de forcer un re-render après un court délai
      setTimeout(() => {
        this.setState({ hasError: false, error: null, errorInfo: null });
      }, 100);
      
      return; // Ne pas bloquer pour les erreurs DOM
    }

    // Pour les autres erreurs, log mais continuer
    if (this.state.errorCount > 5) {
      console.error('🔥 [GlobalErrorBoundary] Trop d\'erreurs, rechargement forcé...');
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }

  render() {
    if (this.state.hasError) {
      // Si erreur DOM et moins de 3 erreurs, essayer de récupérer automatiquement
      if (
        this.state.errorCount < 3 &&
        this.state.error &&
        /removeChild|NotFoundError|DOMException/i.test(String(this.state.error?.message || ''))
      ) {
        // Afficher un message minimal et essayer de continuer
        return (
          <div style={{
            padding: '20px',
            color: '#fff',
            backgroundColor: '#1a1a1a',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '14px'
          }}>
            <div style={{ marginBottom: '12px', opacity: 0.8 }}>
              Récupération en cours...
            </div>
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null, errorInfo: null, errorCount: 0 });
                window.location.reload();
              }}
              style={{
                padding: '10px 20px',
                backgroundColor: '#5fa8ff',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Recharger la page
            </button>
          </div>
        );
      }

      // Pour les autres erreurs ou trop d'erreurs DOM
      return (
        <div style={{
          padding: '24px',
          color: '#fff',
          backgroundColor: '#1a1a1a',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{ fontSize: '18px', marginBottom: '12px' }}>
            Une erreur s'est produite
          </div>
          <div style={{ fontSize: '14px', opacity: 0.7, marginBottom: '20px', textAlign: 'center', maxWidth: '500px' }}>
            {this.state.errorCount > 3 ? (
              <>L'application se recharge automatiquement...</>
            ) : (
              <>L'application continue de fonctionner avec des limitations.</>
            )}
          </div>
          <button
            onClick={() => {
              this.setState({ hasError: false, error: null, errorInfo: null, errorCount: 0 });
              window.location.reload();
            }}
            style={{
              padding: '12px 24px',
              backgroundColor: '#5fa8ff',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '500'
            }}
          >
            Recharger la page
          </button>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <details style={{ marginTop: '20px', maxWidth: '800px', width: '100%' }}>
              <summary style={{ cursor: 'pointer', opacity: 0.7, marginBottom: '10px' }}>
                Détails techniques (dev seulement)
              </summary>
              <pre style={{
                backgroundColor: '#2a2a2a',
                padding: '12px',
                borderRadius: '4px',
                overflow: 'auto',
                fontSize: '12px',
                color: '#ff6b6b'
              }}>
                {String(this.state.error)}
                {this.state.errorInfo && `\n\n${this.state.errorInfo.componentStack}`}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

